'use client';

import { FONT_TEXT } from '@/app/fonts';
import { ShareableChart } from '@/components/blog/ShareableChart';

export function TwoEngineModel() {
  return (
    <ShareableChart title="The Two-Engine Lead Generation Model">
      <h3 className="text-lg font-bold text-gray-900 mb-1" style={{ fontFamily: FONT_TEXT }}>
        The Two-Engine Model
      </h3>
      <p className="text-sm text-gray-500 mb-6" style={{ fontFamily: FONT_TEXT }}>
        Two conversion systems working together to capture every type of visitor
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Engine 1: Landing Pages */}
        <div className="rounded-lg border-2 p-5" style={{ borderColor: '#ff34a7' }}>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold" style={{ backgroundColor: '#ff34a7', fontFamily: FONT_TEXT }}>1</div>
            <h4 className="font-bold text-gray-900" style={{ fontFamily: FONT_TEXT }}>Landing Page Engine</h4>
          </div>
          <div className="space-y-3" style={{ fontFamily: FONT_TEXT }}>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Conversion Rate</span>
              <span className="text-lg font-bold" style={{ color: '#ff34a7' }}>25–35%</span>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-3">
              <div className="h-3 rounded-full" style={{ width: '30%', backgroundColor: '#ff34a7' }} />
            </div>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Dedicated pages for paid campaigns</li>
              <li>• Single purpose: capture the lead</li>
              <li>• No navigation, no distractions</li>
              <li>• Matched to ad messaging</li>
            </ul>
            <div className="pt-2 border-t border-gray-100">
              <span className="text-xs text-gray-400">Best for: Google Ads, Facebook Ads, email campaigns</span>
            </div>
          </div>
        </div>

        {/* Engine 2: Website */}
        <div className="rounded-lg border-2 p-5" style={{ borderColor: '#294bfd' }}>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold" style={{ backgroundColor: '#294bfd', fontFamily: FONT_TEXT }}>2</div>
            <h4 className="font-bold text-gray-900" style={{ fontFamily: FONT_TEXT }}>Website Engine</h4>
          </div>
          <div className="space-y-3" style={{ fontFamily: FONT_TEXT }}>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Conversion Rate</span>
              <span className="text-lg font-bold" style={{ color: '#294bfd' }}>5–15%</span>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-3">
              <div className="h-3 rounded-full" style={{ width: '8%', backgroundColor: '#294bfd' }} />
            </div>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Full site experience for all traffic</li>
              <li>• Builds trust, educates, converts</li>
              <li>• SEO-optimized for organic traffic</li>
              <li>• Multiple conversion points</li>
            </ul>
            <div className="pt-2 border-t border-gray-100">
              <span className="text-xs text-gray-400">Best for: SEO, referrals, direct traffic, social</span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4 text-center p-3 rounded-lg" style={{ backgroundColor: '#f0f4ff', fontFamily: FONT_TEXT }}>
        <p className="text-sm text-gray-700">
          <strong>Together:</strong> Landing pages capture paid traffic at 25-35%. Your website captures everything else at 5-15%. 
          Without both engines, you're leaving leads on the table.
        </p>
      </div>
    </ShareableChart>
  );
}
